export const LEGAL_UPDATE_DATE = "15/05/2026";

export const PRIVACY_POLICY_CONTENT = {
  title: "Política de Privacidade",
  eyebrow: "POLÍTICA DE PRIVACIDADE — ORION33",
  intro: [
    "Esta Política de Privacidade explica como o ORION33 coleta, utiliza, armazena, compartilha e protege os dados dos usuários.",
    "Ao utilizar a plataforma, o usuário declara estar ciente das condições descritas nesta Política.",
  ],
  sections: [
    {
      title: "1. Quem somos",
      paragraphs: [
        "O ORION33 é uma plataforma digital destinada ao controle e acompanhamento de banca, torneios, resultados e indicadores relacionados à atividade de poker.",
        "Para assuntos relacionados à privacidade, proteção de dados, suporte ou solicitações do usuário, o canal oficial de contato é:",
        "contato@orion33.com.br",
      ],
    },
    {
      title: "2. Dados que podemos coletar",
      paragraphs: [
        "O ORION33 poderá coletar dados necessários para funcionamento da plataforma, cadastro, autenticação, segurança e uso dos recursos disponíveis.",
      ],
      subsections: [
        {
          title: "2.1. Dados de cadastro",
          items: [
            "nome;",
            "e-mail;",
            "senha criptografada ou credenciais de autenticação;",
            "foto de perfil, quando aplicável;",
            "informações de conta vinculada, como login por Google, quando utilizado.",
          ],
        },
        {
          title: "2.2. Dados inseridos pelo usuário",
          items: [
            "torneios cadastrados;",
            "buy-ins;",
            "premiações;",
            "resultados;",
            "banca inicial e evolução da banca;",
            "modalidades;",
            "observações;",
            "registros de equipes, quando aplicável;",
            "demais informações inseridas voluntariamente pelo usuário.",
          ],
        },
        {
          title: "2.3. Dados técnicos",
          items: [
            "endereço IP;",
            "data e horário de acesso;",
            "tipo de dispositivo;",
            "navegador;",
            "sistema operacional;",
            "logs de autenticação e segurança;",
            "identificadores técnicos necessários ao funcionamento da plataforma.",
          ],
        },
        {
          title: "2.4. Dados de pagamento",
          paragraphs: [
            "Quando houver contratação de plano pago, os dados de pagamento poderão ser tratados por provedores terceirizados de pagamento.",
            "O ORION33 poderá receber informações limitadas sobre a transação, como status do pagamento, plano contratado, data da contratação e identificação da assinatura.",
            "O ORION33 não tem como objetivo armazenar dados completos de cartão de crédito.",
          ],
        },
      ],
    },
    {
      title: "3. Para que usamos os dados",
      paragraphs: ["Utilizamos os dados para:"],
      items: [
        "criar e gerenciar a conta do usuário;",
        "permitir o acesso à plataforma;",
        "registrar torneios, resultados e informações fornecidas pelo usuário;",
        "calcular indicadores como ROI, ABI, lucro, prejuízo e evolução da banca;",
        "gerar dashboards, gráficos e relatórios;",
        "processar pagamentos e assinaturas, quando aplicável;",
        "enviar e-mails transacionais, como confirmação de cadastro, redefinição de senha e avisos importantes;",
        "prestar suporte;",
        "prevenir fraudes, abusos e acessos não autorizados;",
        "melhorar funcionalidades, desempenho e segurança;",
        "cumprir obrigações legais, regulatórias ou ordens de autoridades competentes.",
      ],
    },
    {
      title: "4. Bases legais para tratamento",
      paragraphs: [
        "O tratamento dos dados poderá ocorrer com base nas hipóteses previstas na legislação aplicável, incluindo:",
      ],
      items: [
        "execução de contrato ou procedimentos relacionados ao uso da plataforma;",
        "cumprimento de obrigação legal ou regulatória;",
        "legítimo interesse para segurança, prevenção de fraudes, melhoria da plataforma e suporte;",
        "consentimento, quando necessário;",
        "exercício regular de direitos em processos judiciais, administrativos ou arbitrais.",
      ],
    },
    {
      title: "5. Compartilhamento de dados",
      paragraphs: [
        "O ORION33 poderá compartilhar dados com terceiros apenas quando necessário para operação da plataforma, incluindo:",
      ],
      items: [
        "provedores de hospedagem e infraestrutura;",
        "serviços de banco de dados;",
        "provedores de autenticação;",
        "serviços de envio de e-mails;",
        "processadores de pagamento;",
        "ferramentas de análise, segurança e monitoramento;",
        "autoridades públicas, quando exigido por lei, ordem judicial ou obrigação regulatória.",
      ],
      closing: ["O ORION33 não vende dados pessoais dos usuários."],
    },
    {
      title: "6. Cookies e tecnologias semelhantes",
      paragraphs: [
        "O ORION33 poderá utilizar cookies, tokens, armazenamento local e tecnologias semelhantes para:",
      ],
      items: [
        "manter o usuário autenticado;",
        "lembrar preferências;",
        "proteger a conta;",
        "medir uso da plataforma;",
        "melhorar desempenho e experiência.",
      ],
      closing: [
        "O usuário pode gerenciar cookies diretamente nas configurações do navegador, mas a desativação de alguns recursos pode afetar o funcionamento da plataforma.",
      ],
    },
    {
      title: "7. Armazenamento e segurança",
      paragraphs: [
        "O ORION33 adota medidas técnicas e organizacionais razoáveis para proteger os dados contra acesso não autorizado, perda, alteração, destruição ou uso indevido.",
        "Essas medidas podem incluir:",
      ],
      items: [
        "controle de acesso;",
        "autenticação segura;",
        "criptografia ou técnicas equivalentes quando aplicável;",
        "monitoramento de logs;",
        "restrição de acesso a dados sensíveis;",
        "backups e mecanismos de recuperação.",
      ],
      closing: [
        "Apesar dos esforços de segurança, nenhum sistema digital é totalmente imune a falhas, ataques ou acessos indevidos.",
      ],
    },
    {
      title: "8. Prazo de retenção dos dados",
      paragraphs: [
        "Os dados serão mantidos pelo tempo necessário para cumprir as finalidades descritas nesta Política, incluindo:",
      ],
      items: [
        "manutenção da conta do usuário;",
        "prestação dos serviços contratados;",
        "cumprimento de obrigações legais;",
        "prevenção de fraudes;",
        "exercício regular de direitos;",
        "cumprimento de prazos legais ou regulatórios.",
      ],
      closing: [
        "Após o encerramento da conta, alguns dados poderão ser mantidos pelo período necessário para cumprimento de obrigações legais ou defesa de direitos.",
      ],
    },
    {
      title: "9. Direitos do usuário",
      paragraphs: [
        "O usuário poderá solicitar, conforme a legislação aplicável:",
      ],
      items: [
        "confirmação da existência de tratamento de dados;",
        "acesso aos dados;",
        "correção de dados incompletos, inexatos ou desatualizados;",
        "anonimização, bloqueio ou eliminação de dados desnecessários, excessivos ou tratados em desconformidade;",
        "portabilidade dos dados, quando aplicável;",
        "informação sobre compartilhamento de dados;",
        "revogação do consentimento, quando aplicável;",
        "eliminação dos dados tratados com consentimento, observadas as exceções legais.",
      ],
      closing: [
        "As solicitações podem ser feitas pelo e-mail:",
        "contato@orion33.com.br",
      ],
    },
    {
      title: "10. Exclusão de conta e dados",
      paragraphs: [
        "O usuário poderá solicitar a exclusão de sua conta e de seus dados pelo e-mail contato@orion33.com.br.",
        "Após a solicitação, o ORION33 poderá excluir ou anonimizar os dados, salvo quando a manutenção for necessária para:",
      ],
      items: [
        "cumprimento de obrigação legal ou regulatória;",
        "prevenção de fraude;",
        "exercício regular de direitos;",
        "cumprimento de contrato ou obrigações pendentes;",
        "outras hipóteses permitidas pela legislação.",
      ],
    },
    {
      title: "11. Dados de menores de idade",
      paragraphs: [
        "O ORION33 não é destinado a menores de 18 anos.",
        "Ao utilizar a plataforma, o usuário declara ser maior de idade e plenamente capaz para aceitar esta Política e os Termos de Uso.",
        "Caso seja identificado cadastro de menor de idade, a conta poderá ser suspensa ou encerrada.",
      ],
    },
    {
      title: "12. Transferência internacional de dados",
      paragraphs: [
        "Alguns fornecedores utilizados pelo ORION33 podem armazenar ou processar dados fora do Brasil.",
        "Quando isso ocorrer, o ORION33 buscará utilizar fornecedores que adotem medidas adequadas de segurança e proteção de dados, conforme a legislação aplicável.",
      ],
    },
    {
      title: "13. Alterações nesta Política",
      paragraphs: [
        "Esta Política de Privacidade poderá ser atualizada periodicamente para refletir mudanças legais, técnicas ou operacionais.",
        "Quando houver alterações relevantes, o usuário poderá ser comunicado por e-mail, aviso na plataforma ou outro meio adequado.",
        "A data da última atualização estará sempre indicada no início deste documento.",
      ],
    },
    {
      title: "14. Contato",
      paragraphs: [
        "Para dúvidas, solicitações, suporte ou assuntos relacionados à privacidade, entre em contato pelo e-mail:",
        "contato@orion33.com.br",
      ],
    },
  ],
};

export const TERMS_CONTENT = {
  title: "Termos de Uso",
  eyebrow: "TERMOS DE USO — ORION33",
  intro: [
    "Bem-vindo ao ORION33.",
    "Estes Termos de Uso regulam o acesso e a utilização da plataforma ORION33, disponibilizada pelo próprio ORION33, com contato oficial pelo e-mail contato@orion33.com.br.",
    "Ao criar uma conta, acessar ou utilizar a plataforma, você declara que leu, compreendeu e concorda com estes Termos de Uso.",
  ],
  sections: [
    {
      title: "1. Sobre o ORION33",
      paragraphs: [
        "O ORION33 é uma plataforma digital destinada ao controle, organização e acompanhamento de dados relacionados à banca de poker, torneios, buy-ins, premiações, ROI, ABI, evolução de resultados e demais informações inseridas pelo próprio usuário.",
        "A plataforma tem finalidade informativa, organizacional e gerencial, não constituindo serviço financeiro, casa de apostas, intermediação de jogos, consultoria financeira, recomendação de investimento ou garantia de resultados.",
      ],
    },
    {
      title: "2. Cadastro e conta do usuário",
      paragraphs: [
        "Para utilizar determinados recursos do ORION33, o usuário poderá precisar criar uma conta, fornecendo informações verdadeiras, completas e atualizadas.",
        "O usuário é responsável por:",
      ],
      items: [
        "manter a confidencialidade de suas credenciais de acesso;",
        "não compartilhar sua conta com terceiros sem autorização;",
        "manter seus dados cadastrais atualizados;",
        "comunicar qualquer uso não autorizado de sua conta.",
      ],
      closing: [
        "O ORION33 não se responsabiliza por danos causados por uso indevido da conta quando decorrentes de culpa, negligência ou compartilhamento indevido de dados de acesso pelo próprio usuário.",
      ],
    },
    {
      title: "3. Uso permitido da plataforma",
      paragraphs: [
        "O usuário se compromete a utilizar o ORION33 de forma lícita, ética e compatível com estes Termos.",
        "É proibido:",
      ],
      items: [
        "utilizar a plataforma para fins ilegais, fraudulentos ou abusivos;",
        "tentar invadir, modificar, copiar, danificar ou comprometer a segurança do sistema;",
        "inserir dados falsos, ofensivos, ilegais ou que violem direitos de terceiros;",
        "utilizar robôs, scripts ou automações que prejudiquem o funcionamento da plataforma;",
        "revender, sublicenciar ou explorar comercialmente a plataforma sem autorização;",
        "praticar engenharia reversa, cópia de código, extração de dados ou tentativa de reprodução não autorizada do sistema.",
      ],
    },
    {
      title: "4. Dados inseridos pelo usuário",
      paragraphs: [
        "O usuário é responsável pelas informações que cadastra na plataforma, incluindo dados sobre torneios, valores, premiações, resultados, observações, equipes e demais registros.",
        "O ORION33 poderá utilizar esses dados para:",
      ],
      items: [
        "exibir gráficos, indicadores e relatórios dentro da própria conta;",
        "calcular métricas como ROI, ABI, lucro, prejuízo, volume jogado e evolução da banca;",
        "melhorar a experiência do usuário;",
        "manter a segurança, integridade e funcionamento da plataforma.",
      ],
      closing: [
        "O ORION33 não garante a veracidade, exatidão ou completude dos dados inseridos pelo usuário.",
      ],
    },
    {
      title: "5. Natureza dos indicadores e relatórios",
      paragraphs: [
        "Os indicadores exibidos pelo ORION33 são calculados com base nos dados informados pelo próprio usuário.",
        "Esses indicadores não representam promessa de rentabilidade, recomendação estratégica, orientação profissional, consultoria financeira ou garantia de desempenho futuro.",
        "O usuário reconhece que decisões tomadas com base nos dados da plataforma são de sua exclusiva responsabilidade.",
      ],
    },
    {
      title: "6. Planos, pagamentos e assinatura",
      paragraphs: [
        "O ORION33 poderá oferecer planos gratuitos, pagos, promocionais ou personalizados.",
        "As condições de preço, periodicidade, recursos disponíveis, limitações e forma de cobrança serão informadas no momento da contratação.",
        "Caso exista assinatura recorrente, o usuário poderá cancelar conforme as regras apresentadas na própria plataforma ou pelo canal de contato.",
        "Valores já pagos poderão seguir política própria de reembolso, conforme informado no momento da contratação e conforme a legislação aplicável.",
      ],
    },
    {
      title: "7. Disponibilidade da plataforma",
      paragraphs: [
        "O ORION33 buscará manter a plataforma disponível de forma contínua e segura, mas não garante funcionamento ininterrupto, livre de erros ou indisponibilidades.",
        "A plataforma poderá ficar temporariamente indisponível por motivos como:",
      ],
      items: [
        "manutenção técnica;",
        "atualizações;",
        "falhas de infraestrutura;",
        "problemas em serviços de terceiros;",
        "eventos fora do controle razoável do ORION33.",
      ],
    },
    {
      title: "8. Serviços de terceiros",
      paragraphs: [
        "O ORION33 poderá utilizar serviços de terceiros para autenticação, hospedagem, banco de dados, envio de e-mails, pagamentos, análise de uso e demais funcionalidades necessárias à operação da plataforma.",
        "O uso desses serviços poderá estar sujeito aos próprios termos e políticas dos respectivos fornecedores.",
      ],
    },
    {
      title: "9. Propriedade intelectual",
      paragraphs: [
        "A marca, nome, identidade visual, layout, código, textos, funcionalidades, design, banco de dados, estrutura, componentes e demais elementos do ORION33 pertencem ao ORION33 ou a seus licenciadores.",
        "O uso da plataforma não concede ao usuário qualquer direito de propriedade intelectual sobre o ORION33.",
        "É proibida a cópia, reprodução, distribuição, modificação ou exploração comercial de qualquer parte da plataforma sem autorização prévia e expressa.",
      ],
    },
    {
      title: "10. Suspensão ou encerramento de conta",
      paragraphs: [
        "O ORION33 poderá suspender ou encerrar o acesso do usuário caso identifique:",
      ],
      items: [
        "violação destes Termos;",
        "uso fraudulento, abusivo ou ilegal;",
        "tentativa de comprometer a segurança da plataforma;",
        "inadimplência, quando aplicável;",
        "ordem judicial, administrativa ou obrigação legal.",
      ],
      closing: [
        "O usuário também poderá solicitar o encerramento de sua conta pelo e-mail contato@orion33.com.br.",
      ],
    },
    {
      title: "11. Limitação de responsabilidade",
      paragraphs: [
        "Na máxima extensão permitida pela legislação aplicável, o ORION33 não será responsável por:",
      ],
      items: [
        "prejuízos decorrentes de dados incorretos inseridos pelo usuário;",
        "decisões tomadas com base nos relatórios da plataforma;",
        "perdas financeiras, esportivas ou operacionais relacionadas à prática de poker;",
        "falhas causadas por terceiros, internet, dispositivos, navegadores ou serviços externos;",
        "indisponibilidades temporárias da plataforma;",
        "uso indevido da conta pelo próprio usuário ou por terceiros com acesso às credenciais.",
      ],
    },
    {
      title: "12. Alterações nos Termos",
      paragraphs: [
        "O ORION33 poderá alterar estes Termos de Uso a qualquer momento para refletir mudanças legais, técnicas, comerciais ou operacionais.",
        "Quando as alterações forem relevantes, o usuário poderá ser comunicado por e-mail, aviso na plataforma ou outro meio adequado.",
        "O uso contínuo da plataforma após a atualização representa concordância com a nova versão dos Termos.",
      ],
    },
    {
      title: "13. Legislação aplicável",
      paragraphs: [
        "Estes Termos serão regidos pelas leis da República Federativa do Brasil.",
        "Eventuais conflitos deverão ser resolvidos conforme a legislação brasileira aplicável.",
      ],
    },
    {
      title: "14. Contato",
      paragraphs: [
        "Em caso de dúvidas sobre estes Termos de Uso, entre em contato pelo e-mail:",
        "contato@orion33.com.br",
      ],
    },
  ],
};
